import type { InputHTMLAttributes, ReactNode } from 'react';
import { Icon, type IconName } from '@/components/foundations';

export type TextFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> & {
  id: string;
  label: ReactNode;
  /** Texto de apoio abaixo do campo (`.help`). */
  hint?: ReactNode;
  error?: ReactNode;
  icon?: IconName;
  /** Conteúdo depois do input, dentro da caixa (ex.: botão de mostrar senha). */
  suffix?: ReactNode;
};

/** Campo com rótulo do pacote (`.field` > `label` + `.input`). */
export function TextField({ id, label, hint, error, icon, suffix, ...input }: TextFieldProps) {
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="input" style={error ? { borderColor: 'var(--red)' } : undefined}>
        {icon && <Icon name={icon} />}
        <input id={id} aria-invalid={error ? true : undefined} aria-describedby={describedBy} {...input} />
        {suffix}
      </div>
      {error ? (
        <span className="help" id={`${id}-error`} role="alert" style={{ color: 'var(--red)' }}>{error}</span>
      ) : (
        hint && <span className="help" id={`${id}-hint`}>{hint}</span>
      )}
    </div>
  );
}
